(() => {
  'use strict';

  const FLAG = '__entinaComplementaryAIODV1';
  if (window[FLAG]) return;
  window[FLAG] = true;

  const ROOT = () => window.Shopify?.routes?.root || '/';
  const SECTION_IDS = ['cart-drawer', 'header-cart-status'];

  const parse = (html) => new DOMParser().parseFromString(String(html || ''), 'text/html');

  function replaceSections(sections) {
    if (!sections || typeof sections !== 'object') return;

    const drawerHTML = sections['cart-drawer'];
    if (typeof drawerHTML === 'string' && drawerHTML.trim()) {
      const incoming = parse(drawerHTML).querySelector('.js-cart-drawer-wrapper');
      const current = document.querySelector('#cartDrawer .js-cart-drawer-wrapper');
      if (incoming && current) current.innerHTML = incoming.innerHTML;
    }

    const headerHTML = sections['header-cart-status'];
    if (typeof headerHTML === 'string' && headerHTML.trim()) {
      const doc = parse(headerHTML);
      const incoming = doc.querySelector('#headerCartStatus') || doc.querySelector('#header-cart-status') || doc.body.firstElementChild;
      const current = document.querySelector('#headerCartStatus') || document.querySelector('#header-cart-status');
      if (incoming && current) current.innerHTML = incoming.innerHTML;
    }
  }

  async function reconcileSections() {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', SECTION_IDS.join(','));
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Cart section refresh failed: ' + response.status);
    replaceSections(await response.json());
  }

  function openDrawer(opener) {
    const drawer = document.querySelector('ecx-cart-drwr');
    if (drawer && typeof drawer.openDrawer === 'function') {
      drawer.openDrawer(opener);
    }
  }

  function setVariantPrice(form) {
    const select = form.querySelector('[data-entina-fbt-variant]');
    if (!select) return;
    const option = select.options[select.selectedIndex];
    const card = form.closest('[data-entina-fbt-card]');
    if (!card || !option) return;

    const price = card.querySelector('[data-entina-fbt-price]');
    const compare = card.querySelector('[data-entina-fbt-compare]');
    if (price && option.dataset.priceText) price.textContent = option.dataset.priceText;

    if (compare) {
      const compareText = option.dataset.compareText || '';
      compare.textContent = compareText;
      compare.hidden = !compareText;
    }
  }

  async function addFromForm(form, submitter) {
    const input = form.querySelector('[name="id"]');
    const variantId = Number(input?.value || 0);
    if (!variantId) throw new Error('Please choose an available option.');

    const button = submitter || form.querySelector('[data-entina-fbt-submit]');
    const label = button?.querySelector('[data-entina-fbt-button-label]');
    const error = form.querySelector('[data-entina-fbt-error]');
    const oldLabel = label?.textContent || 'Add to cart';

    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    if (label) label.textContent = 'Adding…';

    try {
      const response = await fetch(ROOT() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: SECTION_IDS,
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();
      if (!response.ok || data?.status) {
        throw new Error(data?.description || data?.message || 'Unable to add this item.');
      }

      // Shopify renders these sections after the cart mutation, so app-based
      // automatic discounts (AIOD) remain the single source of discount math.
      replaceSections(data.sections);
      openDrawer(button);

      // One server reconciliation avoids stale drawer HTML after app-discount
      // recalculation or third-party cart observers. No discount is calculated here.
      await new Promise(resolve => setTimeout(resolve, 220));
      await reconcileSections();

      document.dispatchEvent(new CustomEvent('entina:fbt:added', {
        detail: { variantId, source: 'complementary-products' }
      }));

      if (label) label.textContent = 'Added';
      setTimeout(() => {
        if (label) label.textContent = oldLabel;
      }, 1200);
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
      if (label && label.textContent === 'Adding…') label.textContent = oldLabel;
    }
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-entina-fbt-variant]');
    if (!select) return;
    const form = select.closest('[data-entina-fbt-form]');
    if (form) setVariantPrice(form);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-entina-fbt-form]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();

    addFromForm(form, event.submitter).catch((err) => {
      const error = form.querySelector('[data-entina-fbt-error]');
      if (error) {
        error.textContent = err?.message || 'Unable to add this item. Please try again.';
        error.hidden = false;
      }
      console.error('[ENTINA FBT / AIOD]', err);
    });
  }, true);
})();
